export const defStyle = {
  easing: "ease-in-out",
  duration: "0.25s",
};
